import MallitemAdvancedSelector from './mallitem-advanced-selector.vue'

MallitemAdvancedSelector.install = function (Vue) {
	Vue.component(MallitemAdvancedSelector.name, MallitemAdvancedSelector);
}

export default MallitemAdvancedSelector;